import axios from 'axios'
import Vue from 'vue'
import { API_BASE_URL } from './api-config';

const ADMIN_API = `${API_BASE_URL}/admin`;

export const adminApi = axios.create({
  baseURL: ADMIN_API,
  headers: {
    'Content-Type': 'application/json',
  },
});

adminApi.interceptors.request.use(config => {
  const password = localStorage.getItem('ADMIN_PASSWORD');
  if (password) {
    config.headers['X-Admin-Password'] = password;
  }
  return config;
});

adminApi.interceptors.response.use(
  response => response,
  error => {
    console.log(error);
    let message = 'Ошибка запроса';
    if (error.response && error.response.status === 401) {
      message = 'Неверный пароль администратора';
    } else if (error.response && error.response.data) {
      message = error.response.data.message || error.response.data;
    } else if (error.message) {
      message = error.message;
    }

    Vue.toasted.show(message, {
      type: 'error',
      duration: 5000
    });

    return Promise.reject(error);
  }
);

/**
 * Streams NDJSON progress lines from a long-running admin action (parse/update documentation).
 * onEvent(obj) is called once per JSON line, e.g. { message, done }. `body` is sent as the
 * JSON request body (e.g. vector store name / chunking params for the update endpoint).
 */
export function postAdminStream(endpoint, onEvent, onError, onDone, body = {}) {
  const controller = new AbortController();
  const abortSignal = controller.signal;

  let buf = '';
  let lastLength = 0;

  const password = localStorage.getItem('ADMIN_PASSWORD');

  const cfg = {
    headers: {
      'Content-Type': 'application/json',
      'X-Admin-Password': password || '',
    },
    onDownloadProgress: (progressEvent) => {
      const xhr = progressEvent.currentTarget || progressEvent.target;
      const text = xhr.responseText;

      const chunk = text.substring(lastLength);
      lastLength = text.length;
      if (!chunk) return;

      buf += chunk;

      let idx;
      while ((idx = buf.indexOf('\n')) >= 0) {
        const line = buf.slice(0, idx).trim();
        buf = buf.slice(idx + 1);

        if (!line) continue;
        try {
          const obj = JSON.parse(line);
          onEvent && onEvent(obj);
        } catch (ex) {
          console.error('Broken JSON line:', line);
        }
      }
    },
    signal: abortSignal,
  };

  adminApi.post(`${ADMIN_API}${endpoint}`, body, cfg)
    .then(() => {
      const rest = buf.trim();
      if (rest) {
        try {
          onEvent && onEvent(JSON.parse(rest));
        } catch (ex) {}
      }
      onDone && onDone();
    })
    .catch((err) => {
      const canceled = err.name === 'CanceledError' || err.code === 'ERR_CANCELED';
      if (!canceled) onError && onError(err);
    });

  return { cancel: () => controller.abort() };
}



// WEBPACK FOOTER //
// ./src/components/api/admin-api.js